/**
 * Bottom-left scale for every scene. Not part of the telemetry plate.
 * A race and the workshop use the film-free HUD bar. The editor uses the same
 * corner inside its own panel, and can hide it.
 */
import type { JSX } from 'preact';
import { setPanel } from './panels.ts';
import { ScaleMeter } from './scale-meter.tsx';
import './sceneScale.css';

export type SceneScaleTone = 'hud' | 'editor';

export type SceneScaleProps = {
  label: string;
  visible: boolean;
  tone: SceneScaleTone;
};

export type SceneScale = {
  setLabel: (label: string) => void;
  setVisible: (on: boolean) => void;
  destroy: () => void;
};

export function SceneScalePanel({ label, visible, tone }: SceneScaleProps): JSX.Element | null {
  if (!visible) {
    return null;
  }

  const hud = tone === 'hud';

  return (
    <aside
      class={hud ? 'scene-scale play-scale' : 'scene-scale editor-scale ui-panel'}
      aria-label={hud ? 'Scale' : 'Map scale'}
    >
      <ScaleMeter label={label} />
    </aside>
  );
}

export function mountSceneScale(tone: SceneScaleTone): SceneScale {
  let label = '';
  let visible = true;

  const push = (): void => {
    setPanel('sceneScale', { label, visible, tone });
  };

  push();

  return {
    setLabel: (next) => {
      label = next;
      push();
    },
    setVisible: (on) => {
      visible = on;
      push();
    },
    destroy: () => setPanel('sceneScale', null),
  };
}
